import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * 设备检测和自动跳转组件
 * 根据用户设备类型自动跳转到对应页面
 */
export default function DeviceRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )

    // 或者使用更精确的检测方法
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    const isSmallScreen = window.innerWidth <= 768

    // 综合判断：触摸设备 + 小屏幕 = 移动设备
    const shouldUseMobile = isMobile || (isTouchDevice && isSmallScreen)

    if (shouldUseMobile) {
      console.log('Detected mobile device, redirecting to /mobile')
      navigate('/mobile', { replace: true })
    } else {
      console.log('Detected desktop device, redirecting to /admin')
      navigate('/admin', { replace: true })
    }
  }, [navigate])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-100 mx-auto"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-400">正在跳转...</p>
      </div>
    </div>
  )
}
